import React, { Component } from 'react';
import { HttpRequestService } from '../services/HttpRequestService';
import { UserService } from '../services/UserService';

class ProductTypeSelect extends Component {

    constructor(props) {
        super(props);
        this.state = { productTypes: [] };
        this.getProductTypes = this.getProductTypes.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.http = new HttpRequestService();
    }

    componentDidMount() {
        this.getProductTypes();
    }

    componentWillUnmount() {

    }

    getProductTypes() {
        this.http.get('/api/Orders/GetProductTypes', null).then(data => {
            if (UserService.IsUserInRole("Field Rep")) {
                // sort product types
                // Put Samples/Literature on top
                const samplesIndex = data.findIndex(d => d.key === "8");
                const samplesAndLiterature = data.splice(samplesIndex, 1)[0];
                data.splice(0, 0, samplesAndLiterature);
            }

            this.setState({ productTypes: data });
            if (data.length > 0 && this.props.value === 0) {
                this.props.onChange(data[0].key);
            }
        });
    }

    handleChange(e) {
        this.props.onChange(e.target.value);
    }

    render() {
        var options = this.state.productTypes.map((site) =>
            <option key={site.key} value={site.key}>{site.value}</option>
        );

        return (
            <select className="form-control product-type-select" value={this.props.value} onChange={this.handleChange} size={this.props.size}>
                {this.props.hasAllOption === true &&
                    <option value="-1">-- ALL --</option>
                }
                {options}
            </select>
        );
    }
}
export default ProductTypeSelect
